import React from "react";
import { 
  Pagination as ReactstrapPagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { withPropsOnChange, compose, onlyUpdateForKeys } from "recompose";
import { range, map, pick } from "lodash";
import { Trans } from "react-i18next";

export const Pagination = ({
  pages,
  currentPage,
  onPreviousClick,
  onNextClick,
  onFirstClick,
  onLastClick,
  atEnd,
  atStart,
  onLimitChanged =(number)=>{console.log('pagination ', number)},
  limit,
  ...props
}) => {
  const paginationProps = pick(props, "className", "style", "size", "tag");

  return (
    <div className="">
    <ReactstrapPagination {...paginationProps} className="d-flex justify-content-end">
      <PaginationItem disabled={atStart}>
        <PaginationLink first href="#" onClick={onFirstClick} />
      </PaginationItem>
      <PaginationItem disabled={atStart}>
        <PaginationLink previous href="#" onClick={onPreviousClick} />
      </PaginationItem>
      {pages.map((i) => (
        <PaginationItem active={i.active} key={i.page}>
          <PaginationLink href="#" onClick={i.onClick}>
            {i.page}
          </PaginationLink>
        </PaginationItem>
      ))}
      <PaginationItem disabled={atEnd}>
        <PaginationLink next href="#" onClick={onNextClick} />
      </PaginationItem>
      <PaginationItem disabled={atEnd}>
        <PaginationLink last href="#" onClick={onLastClick} />
      </PaginationItem>
    </ReactstrapPagination>
      <div className="col-12 tex-right p-0">
        <span className="text-secondary"><Trans>Items Per Page</Trans>:</span>
        {[25, 50, 100].map((number) => (
          <button className={`btn btn-link link shadow-none pr-0 pl-1 ml-1 mr-0 ${limit===number? 'text-muted':'text-success'}`} disabled={limit===number} onClick={(e) => {onLimitChanged(number) }}>
            {number}
          </button>
        ))}
      </div>
    </div>
  );
};

const enhance = compose(
  onlyUpdateForKeys(["count", "offset", "onOffsetChanged", "limit", "onLimitChanged"]),
  withPropsOnChange(
    ["count", "offset", "onOffsetChanged", "limit", "noPages", "onLimitChanged"],
    ({ count, limit, offset, onOffsetChanged, noPages, onLimitChanged }) => {
      const numPages = Math.ceil(count / limit);
      const currentPage = Math.floor(offset / limit) + 1;

      const maxVisiblePages = 5; // Number of visible page links
      const halfVisible = Math.floor(maxVisiblePages / 2);
      let startPage = Math.max(1, currentPage - halfVisible);
      let endPage = Math.min(numPages, currentPage + halfVisible);

      // Adjust the start and end pages if they are out of bounds
      if (currentPage - halfVisible < 1) {
        endPage = Math.min(numPages, endPage + (halfVisible - (currentPage - 1)));
      }

      if (
        currentPage + halfVisible > numPages
      ) {
        startPage = Math.max(1, startPage - (currentPage + halfVisible - numPages));
      }

      return {
        currentPage,
        atEnd: currentPage === numPages,
        atStart: currentPage === 1,
        onNextClick: (e) => {
          e.preventDefault();
          onOffsetChanged(offset + limit);
        },
        onPreviousClick: (e) => {
          e.preventDefault();
          const newOffset = offset - limit;
          if (newOffset < 0) return;
          onOffsetChanged(newOffset);
        },
        onFirstClick: (e) => {
          e.preventDefault();
          return onOffsetChanged(0);
        },
        onLastClick: (e) => {
          e.preventDefault();
          return onOffsetChanged((numPages - 1) * limit);
        },
        pages: map(noPages ? [] : range(startPage, endPage + 1), (i) => ({
          page: i,
          onClick: (e) => {
            e.preventDefault();
            return onOffsetChanged((i - 1) * limit);
          },
          active: i === currentPage,
        })),
      };
    }
  )
);

export default enhance(Pagination);
